import React, { useEffect, useMemo, useState } from 'react';
import ReactAsyncSelect from 'react-select/async';
import { SelectValue } from './Select';
import { FieldError } from 'react-hook-form';
import { ActionMeta, SingleValue } from 'react-select';
// @ts-ignore
import styles from './Select.module.scss';
import { NCZIReferenceSelectError } from '../../../Modules/Nczi/Components/ReferenceSearchSelect/NCZIReferenceSearchSelectField';
import { NCZIExtensionSelectError } from '../../../Modules/Nczi/Components/ExtensionSearchSelect/NCZIExtensionSearchSelectField';

interface AsyncSelectProps<T> {
	onSearch: (
		inputValue: string,
		callback: (options: SelectValue[]) => void,
	) => void;
	onChange?: (newValue: SingleValue<SelectValue>) => void;
	placeholder?: string;
	noOptionsMessage?: string;
	error?: FieldError;
	value?: SelectValue;
	ItemTemplate?: (item: T) => React.ReactElement;
	isClearable?: boolean;
	portal?: boolean;
	isMulti?: boolean;
	components?: object;
	closeMenuOnSelect?: boolean;
	hideSelectedOptions?: boolean;
	isSearchable?: boolean;
}

const AsyncSelect = <T,>({
	onSearch,
	onChange,
	placeholder,
	noOptionsMessage,
	error,
	value,
	ItemTemplate,
	isClearable = true,
	portal = false,
	isMulti = false,
	components,
	closeMenuOnSelect,
	hideSelectedOptions,
	isSearchable,
}: AsyncSelectProps<T>): React.ReactElement => {
	const [innerValue, setInnerValue] = useState<any>();
	const componentsDefault = useMemo(() => {
		const c = { DropdownIndicator: () => null, IndicatorSeparator: () => null };

		if (ItemTemplate) {
			// @ts-ignore
			c['Option'] = ItemTemplate;
		}

		return c;
	}, [ItemTemplate]);

	const handleChange = (newValue: SingleValue<SelectValue>) => {
		if (!newValue) {
			onChange?.({
				value: '',
				label: '',
			});
		} else {
			onChange?.(newValue);
		}
	};

	useEffect(() => {
		setInnerValue(
			value?.label === '' || value?.value === ''
				? null
				: value === undefined
				? null
				: value,
		);
	}, [value]);

	return (
		<div className={styles.wrapper}>
			<ReactAsyncSelect
				styles={
					error
						? {
								control: () => ({
									borderColor: 'red !important',
								}),
						  }
						: {
								menuPortal: base => ({ ...base, zIndex: 9999 }),
						  }
				}
				classNamePrefix={'reactSearchSelect'}
				cacheOptions={false}
				loadOptions={onSearch}
				value={innerValue}
				onChange={handleChange}
				placeholder={placeholder}
				components={components ? components : componentsDefault}
				noOptionsMessage={() => noOptionsMessage}
				isClearable={isClearable}
				menuPortalTarget={portal ? document.body : false}
				isMulti={isMulti}
				closeMenuOnSelect={closeMenuOnSelect}
				hideSelectedOptions={hideSelectedOptions}
				isSearchable={isSearchable}
			/>
		</div>
	);
};

export default AsyncSelect;
